import {
  AFFINITY_CLASS_REASONS,
  AFFINITY_MARK_LABELS,
  AFFINITY_SUBJECT_REASONS,
  type AffinityReason,
} from './affinityReasons'

function markLabel(reason: string | null | undefined, allowed: Set<AffinityReason>): string | undefined {
  if (!reason || !allowed.has(reason as AffinityReason)) return undefined
  return AFFINITY_MARK_LABELS[reason as AffinityReason]
}

export function AffinityMarks({
  classReason,
  subjectReason,
}: {
  classReason?: string | null
  subjectReason?: string | null
}) {
  const labels = [
    markLabel(classReason, AFFINITY_CLASS_REASONS),
    markLabel(subjectReason, AFFINITY_SUBJECT_REASONS),
  ].filter((label): label is string => Boolean(label))
  if (labels.length === 0) return null
  return (
    <span className="flex flex-col text-[10px] leading-tight text-gray-600 dark:text-gray-300">
      {labels.map(label => <span key={label}>{label}</span>)}
    </span>
  )
}
